export default function generateAvatarFileKey(fileName) {
  return `${crypto.randomUUID()}-${fileName}`;
}
